import { forwardRef } from "react";
import { Icon } from "@newsela/angelou";
import ThinArrowSvg from "./ThinArrow.svg.jsx";

const ThinArrow = forwardRef<SVGSVGElement, any>((props, ref) => {
  return <Icon ref={ref} SvgComponent={ThinArrowSvg} {...props} />;
});

ThinArrow.displayName = "ThinArrow";
export default ThinArrow;
